import { Voucher } from 'gql/graphql';
import React from 'react';
import styles from './NumberOfAppliedVouchers.module.scss';

interface NumberOfAppliedVouchersProps {
  vouchers: Voucher[];
}

const NumberOfAppliedVouchers: React.FC<NumberOfAppliedVouchersProps> = ({ vouchers }) => {
  if (!vouchers.length) return null;
  return <div>{vouchers.length} applied</div>;
};

export default NumberOfAppliedVouchers;
